import { noop } from 'lodash';

let passiveOptionAccessed = false;
const options = {
    get passive() {
        return (passiveOptionAccessed = true);
    },
};
if ((window === null || window === void 0 ? void 0 : window.addEventListener) && (window === null || window === void 0 ? void 0 : window.removeEventListener)) {
    window.addEventListener('p', noop, options);
    window.removeEventListener('p', noop, false);
}
const supportsPassiveEvents = passiveOptionAccessed;

export { supportsPassiveEvents as default };
//# sourceMappingURL=supportsPassiveEvents.js.map
